import { useDispatch, useSelector } from "react-redux";
import { URL_PREFIX } from "../../api";
import { ensureAll } from "../../store/foodPackagesSlice";
import { useEffect, useState } from "react";
import Section from "../../components/Section";
import { updateQueryFoodPackages } from "../../store/knownDataSlice";
import { toast } from "react-toastify";
import { DataContainer } from "../../components/DataContainer";



function FoodPackages({ id }) {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    const _foodPackages = useSelector((state) => state.foodPackages.knownFoodPackages);
    const allFoodPackages = Object.values(_foodPackages).sort((a, b) => a.food_package_price - b.food_package_price);

    const [orderedFoodPackages, setOrderedFoodPackages] = useState(() => JSON.parse(data?.["query_food_packages"] || "[]"));
    const [initialOrderedFoodPackages, setInitialOrderedFoodPackages] = useState(() => JSON.parse(data?.["query_food_packages"] || "[]"));

    useEffect(() => {
        const initial = JSON.parse(data?.["query_food_packages"] || "[]");
        setOrderedFoodPackages(initial);
        setInitialOrderedFoodPackages(initial);
    }, [data]);

    useEffect(() => {
        dispatch(ensureAll());
    }, [dispatch]);

    function getCartCount(id) {
        const index = orderedFoodPackages.findIndex((item) => item.id === id);
        if (index === -1) return 0;
        return orderedFoodPackages[index].count;
    }

    function updateCart(id, count) {
        const updatedCount = Math.max(0, count);
        const index = orderedFoodPackages.findIndex((item) => item.id === id);

        if (index === -1) {
            if (updatedCount > 0) {
                setOrderedFoodPackages([...orderedFoodPackages, { id, count: updatedCount }]);
            }
        } else {
            const newCart = [...orderedFoodPackages];
            if (updatedCount > 0) {
                newCart[index] = { ...newCart[index], count: updatedCount };
                setOrderedFoodPackages(newCart);
            } else {
                newCart.splice(index, 1);
                setOrderedFoodPackages(newCart);
            }
        }
    }

    const cartTotal = orderedFoodPackages.reduce((acc, item) => {
        const foodPackage = _foodPackages[item.id];
        return acc + (foodPackage ? foodPackage.food_package_price * item.count : 0);
    }, 0).toFixed(2);

    const hasChanges = JSON.stringify(orderedFoodPackages.sort((a,b) => a.id.localeCompare(b.id))) !== JSON.stringify(initialOrderedFoodPackages.sort((a,b) => a.id.localeCompare(b.id)));

    const handleSaveChanges = async () => {
        await dispatch(updateQueryFoodPackages({ id, foodPackages: JSON.stringify(orderedFoodPackages) }));
        toast.success("Toidupakid salvestatud!");
    };

    if (!Object.keys(_foodPackages).length) return null;

    return (<>
        <hr />

        <Section title="Toitlustuspaketid" initiallyHidden={initialOrderedFoodPackages.length === 0}>
            <DataContainer actionType={"knownData/updateQueryFoodPackages"}>
                <div className="column g16">
                    {allFoodPackages.map((foodPackage) => (
                        <div className="row g8 center-cross" key={foodPackage.food_package_id}>
                            <img
                                src={URL_PREFIX + "/storage/food_package/" + foodPackage.food_package_id.toLowerCase() + ".jpg"}
                                style={{ objectFit: 'cover', width: 128, height: '100%', borderRadius: 4 }}
                                alt={foodPackage.food_package_name}
                            />
                            <div className="column g8">
                                <div className="column">
                                    <b>{foodPackage.food_package_name} • {foodPackage.food_package_price} €</b>
                                    <p>{foodPackage.food_package_description}</p>
                                </div>

                                <div className="row center-cross" style={{ height: 36 }}>
                                    <button style={{ paddingInline: 10, height: '100%' }} onClick={() => updateCart(foodPackage.food_package_id, getCartCount(foodPackage.food_package_id) - 1)}>-</button>
                                    <input style={{ height: '100%', width: 64, textAlign: 'center' }} type="text" value={getCartCount(foodPackage.food_package_id)} onChange={(e) => updateCart(foodPackage.food_package_id, isNaN(parseInt(e.target.value)) ? 0 : parseInt(e.target.value))} onFocus={(e) => e.target.select()} />
                                    <button style={{ paddingInline: 10, height: '100%' }} onClick={() => updateCart(foodPackage.food_package_id, getCartCount(foodPackage.food_package_id) + 1)}>+</button>
                                </div>
                            </div>
                        </div>
                    ))}

                    <hr />

                    <div className="column g16">
                        <div className="row g16" style={{ justifyContent: 'space-between' }}>
                            <b>KOKKU</b>
                            <p>{cartTotal} €</p>
                        </div>
                        <button onClick={handleSaveChanges} disabled={!hasChanges}>Salvesta</button>
                    </div>
                </div>
            </DataContainer>
        </Section>

    </>);
};

export default FoodPackages;